/**
 * SMIL calcMode="spline" pacing, same easing as CSS cubic-bezier / SVG2 keySplines.
 * Chromium does not run SMIL <animate>; sampling this lets the motion match Safari/WebKit.
 */

function cubicCoord(p0, p1, p2, p3, t) {
    const u = 1 - t;
    return u * u * u * p0 + 3 * u * u * t * p1 + 3 * u * t * t * p2 + t * t * t * p3;
}

export function createCubicBezierEasing(x1, y1, x2, y2) {
    return function ease(linearT) {
        if (linearT <= 0) return 0;
        if (linearT >= 1) return 1;

        let low = 0;
        let high = 1;
        let t = linearT;
        for (let i = 0; i < 24; i++) {
            t = (low + high) / 2;
            const x = cubicCoord(0, x1, x2, 1, t);
            if (x < linearT) low = t;
            else high = t;
        }
        return cubicCoord(0, y1, y2, 1, t);
    };
}

/**
 * @param {number} u - global linear progress 0..1 over one cycle
 * @param {number[]} values
 * @param {number[]} keyTimes
 * @param {Array<[number, number, number, number]>} keySplines
 */
export function sampleSmilSpline(u, values, keyTimes, keySplines) {
    const n = values.length - 1;
    let seg = n - 1;
    for (let i = 0; i < n; i++) {
        if (u <= keyTimes[i + 1]) {
            seg = i;
            break;
        }
    }
    const t0 = keyTimes[seg];
    const t1 = keyTimes[seg + 1];
    const span = t1 - t0;
    const localLinear = span > 0 ? (u - t0) / span : 0;
    const [sx1, sy1, sx2, sy2] = keySplines[seg];
    const ease = createCubicBezierEasing(sx1, sy1, sx2, sy2);
    const eased = ease(localLinear);
    return values[seg] + (values[seg + 1] - values[seg]) * eased;
}
